import script from "./V4HomeCourseMain.vue?vue&type=script&setup=true&lang=js"
export * from "./V4HomeCourseMain.vue?vue&type=script&setup=true&lang=js"

import "./V4HomeCourseMain.vue?vue&type=style&index=0&id=bc1add0e&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1add0e"]])

export default __exports__